import { render } from "./v3_idx.vue?vue&type=template&id=c35ca852"
import script from "./v3_idx.vue?vue&type=script&lang=js"
export * from "./v3_idx.vue?vue&type=script&lang=js"

import "./v3_idx.vue?vue&type=style&index=0&id=c35ca852&lang=scss"

import exportComponent from "D:\\Workspace_git\\carrot\\pron_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__